import React, { FC, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { GxMenu, GxMenuItem, GxBadge } from '@garpix/garpix-web-components-react';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import style from './styles/index.module.scss';
import { useSiteConfigurations } from '../../apps/Applications/hooks';
import { TYPE_USER } from '../../const';

interface IMenuItem {
  children: IMenuItem[];
  id: number;
  is_active: boolean;
  menu_type: string;
  parent: null | number;
  target_blank: boolean;
  title: string;
  url: string;
  icon: string;
}

interface IMenus {
  footer_menu: IMenuItem[];
  header_menu: IMenuItem[];
  sidebar_menu: IMenuItem[];
  isOpenSidebar: boolean;
}

const MenuSidebar: FC<IMenus> = ({ sidebar_menu = [], isOpenSidebar }) => {
  const domain = process.env.REACT_APP_DOMAIN_BACKEND;
  const page = useSiteConfigurations();

  const { dispatch, tasksCount, tasks, currentUser } = useStoreon<State, Events>('tasksCount', 'tasks', 'currentUser');

  useEffect(() => { dispatch('taskInfo/getCount') }, [])
  return (
    <GxMenu className={style.menu}>
      {sidebar_menu.map((el) => {
        return (
          <GxMenuItem key={el.id} disabled={el.is_active} className={style['menu-item']}>
            <NavLink
              target={el.target_blank ? '_blank' : '_self'}
              // exact
              className={style['menu-item-link']}
              to={el.url}
            >
              <img
                className={style['menu-item-icon']}
                src={domain + el.icon}
                alt='icon menu item'
                width='30px'
                height='30px'
              />
              {el.url === page.page_tasks && !!tasks && tasksCount !== 0 && currentUser.user_status !== TYPE_USER.VIEWER && <GxBadge className={style['badge']} type='danger' pill pulse>{tasksCount}</GxBadge>}
              <span>{isOpenSidebar ? el.title : null}</span>
            </NavLink>
          </GxMenuItem>
        );
      })}
    </GxMenu>
  );
};

export default MenuSidebar;